import type { IconData } from '@stacksjs/iconify-core'

export const divisionCircleFlat: IconData = {
  "body": "<g fill=\"none\"><path fill=\"#8fbffa\" d=\"M24 1.5C11.574 1.5 1.5 11.574 1.5 24S11.574 46.5 24 46.5S46.5 36.426 46.5 24S36.426 1.5 24 1.5\"/><path fill=\"#2859c5\" fill-rule=\"evenodd\" d=\"M20.5 13a3.5 3.5 0 1 1 7 0a3.5 3.5 0 0 1-7 0m0 22a3.5 3.5 0 1 0 7 0a3.5 3.5 0 0 0-7 0m14.937-7.681c-1.882.084-5.369.181-11.437.181s-9.555-.097-11.437-.181c-1.352-.06-2.835-.746-3.013-2.356q-.049-.427-.05-.963c-.001-.536.018-.678.05-.963c.178-1.61 1.661-2.295 3.013-2.356c1.882-.084 5.369-.181 11.437-.181s9.555.097 11.437.181c1.352.06 2.835.746 3.013 2.356q.049.427.05.963c.001.536-.018.678-.05.963c-.178 1.61-1.661 2.296-3.013 2.356\" clip-rule=\"evenodd\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default divisionCircleFlat
